import React, { useEffect, useState } from 'react';
import './WorkPermit.css';
import { getWorkPermit } from '../queries/getWorkPermit';
import { WorkPermit as IWorkPermit } from '../types';

// Fallback data for work permit
const FALLBACK_WORK_PERMIT_DATA: IWorkPermit = {
  visaStatus: "Work Authorization",
  expiryDate: new Date(),
  summary: "Authorized to work in the country",
  additionalInfo: "Open to relocation and remote opportunities"
};

const WorkPermit: React.FC = () => {
  const [workPermitData, setWorkPermitData] = useState<IWorkPermit | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    async function fetchWorkPermitData() {
      try {
        const data = await getWorkPermit();
        setWorkPermitData(data);
      } catch (err) {
        console.error("Failed to fetch work permit data:", err);
        setError("Failed to load work permit data. Showing sample content.");
        // Use fallback data when API request fails
        setWorkPermitData(FALLBACK_WORK_PERMIT_DATA);
      } finally {
        setLoading(false);
      }
    }
    fetchWorkPermitData();
  }, []);

  if (loading) return <div className="work-permit-loading">Loading work permit information...</div>;
  
  if (error) {
    console.warn(error);
  }

  // If we still don't have data for some reason, use fallback
  const displayData = workPermitData || FALLBACK_WORK_PERMIT_DATA;

  return (
    <div className="work-permit-container">
      <div className="work-permit-card">
        <h2 className="work-permit-headline">🎓 Work Authorization</h2>
        <h3 className="work-permit-subtitle">Vinayak Singh</h3>
        <p className="work-permit-summary">
          I'm currently on a <strong>{displayData.visaStatus}</strong> 🛂, which allows me to work! My authorization is valid, giving me the opportunity to build valuable experience and grow my career. 🌟
        </p>
        <p className="additional-info">{displayData.additionalInfo}</p>
      </div>
    </div>
  );
};

export default WorkPermit;